import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Error from '../views/Error.vue';

const routes = [
  {
    path: '/',
    name: 'Error',
    component: Error,
  },
  {
    path: '/4a',
    name: 'Home',
    component: Home,
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
